module.exports = __webpack_public_path__ + "img/xml.36b81291.svg";